import React from 'react';
import HoverImageTile from './hoverimagetile';
import HighlightedText from './highlightedtext';

const {
    hooks: {useSelector, useBreakpoint},
    components: {generic: {RawHTML}},
    hoc: {withNoProps},
    css: {prefixCSS}
} = polyphony;

const styles = {
    tile: {
        marginBottom: 25,
        position: 'relative',
        overflow: 'hidden',
        height: undefined // this one is here to override a height in HoverImageTile
    },
    innerContainer: prefixCSS({
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexFlow: 'column nowrap'
    })
};

const nl2br = str => typeof str === 'string' ? str.replace(/(\\r)?\n/g, '<br />\n') : str;

const SidebarBox = ({text, image, href}) => {
    const fontSize = useSelector(s => s.measurements.sidebar_font_size);
    return (
        <HoverImageTile className='sidebar-box' style={styles.tile} media={image} href={href}>
            <div style={styles.innerContainer}>
                <HighlightedText style={{fontSize, textAlign: 'center'}}>
                    <RawHTML>{text}</RawHTML>
                </HighlightedText>
            </div>
        </HoverImageTile>
    );
};

const Sidebar = withNoProps(() => {
    const boxes = useSelector(s => s.sidebar ? s.sidebar.boxes : []);
    const additionalHtml = useSelector(s => s.sidebar ? nl2br(s.sidebar.additional_html) : null);
    const isMobile = useBreakpoint() === 'mobile';

    return <aside style={isMobile ? {marginTop: 20} : {}} aria-label="Sidebar">
        {boxes.map(({text, image, href}, key) => <SidebarBox text={text} image={image} href={href} key={key} />)}
        <div role='figure'><RawHTML key="custom_html">{additionalHtml}</RawHTML></div>
    </aside>;
});

export default Sidebar;

